





















































import { Component, Prop, Vue } from "vue-property-decorator";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";

import { IReason } from "@/@types/orders/reason";

@Component({ components: { ChangeDeliteButtons } })
export default class ReasonList extends Vue {
  @Prop({ type: Array, default: () => [] }) reasons!: Array<IReason>;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
}
